"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEventDto = void 0;
const AppDto_1 = require("../apps/AppDto");
const LocationDto_1 = require("../locations/LocationDto");
const LoginDto_1 = require("../logins/LoginDto");
class AnalyticsEventDto {
    constructor(params) {
        this.locationName = "";
        this.screen = "";
        this.category = "";
        this.action = "";
        this.label = "";
        this.parameters = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.locationId = params.locationId;
        this.locationName = params.locationName;
        this.loginId = params.loginId;
        this.screen = params.screen;
        this.category = params.category;
        this.action = params.action;
        this.label = params.label;
        this.parameters = params.parameters;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
        if (params.login !== undefined) {
            this.login = params.login === null ?
                null :
                new LoginDto_1.LoginDto(params.login);
        }
    }
}
exports.AnalyticsEventDto = AnalyticsEventDto;
//# sourceMappingURL=AnalyticsEventDto.js.map